export const SEO_PAGE_NAME          = "SEO_PAGE_NAME"
export const UPDATE_SRC_FROM_PARAMS = "UPDATE_SRC_FROM_PARAMS"
export const UPDATE_PAGE_TYPE       = "UPDATE_PAGE_TYPE"
export const UPDATE_ROUTE_PAGE_DATA = "UPDATE_ROUTE_PAGE_DATA"
export const UPDATE_CITY_PAGE_DATA  = "UPDATE_CITY_PAGE_DATA"
export const UPDATE_PAYDATA         = "UPDATE_PAYDATA"
export const UPDATE_SELECTED_CAB    = "UPDATE_SELECTED_CAB"
export const UPDATE_CAR_TYPE        = "UPDATE_CAR_TYPE"